import { IconProps } from '@app/components/Atoms/Icon'
import React from 'react'

export const ShadcnIcon: React.FC<IconProps> = ({
  onClick,
  className,
  active = false,
  ...rest
}) => {
  const primaryInactive = '#FFFFFF'
  const primaryActive = '#0B2948'

  const stroke = active ? primaryActive : primaryInactive

  return (
    <svg
      {...rest}
      className={className}
      onClick={onClick}
      width="41"
      height="41"
      viewBox="0 0 41 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_shadcn)">
        <path
          d="M14.15 26.85L26.85 14.15"
          stroke={stroke}
          strokeWidth="2.8"
          strokeLinecap="round"
        />
        <path
          d="M19.15 28.85L28.85 19.15"
          stroke={stroke}
          strokeWidth="2.8"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_shadcn">
          <rect width="24" height="24" fill="white" transform="translate(8.5 8.5)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default ShadcnIcon
